import { Grid, withTheme, Card, Typography } from 'material-ui';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import getResourceIconFromType from '../utils/ResourceIconFromType';

class ResourceIndexGrid extends Component {
  render() {
    return (
      <Grid container direction='row' justify='flex-start' alignItems='stretch' spacing={24} style={{padding: '12px 24px'}} {...this.props.gridContainerProps}>
        {
          this.props.indexed.map((resourceID, index) => {
            var resourceInfo = this.props.resources[resourceID];
            //TODO make the items be variable height, no fixed rows
            return (
              <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={index} {...this.props.gridItemProps}>
                <Link to={'/resources/' + resourceID} style={{textDecoration: 'none'}}>
                  <Card style={{ padding: 16, height: '100%' }}>
                    
                    <Typography variant='display1' style={{overflowWrap: 'break-word'}}>
                      {getResourceIconFromType(resourceInfo.type, {style: {float: 'left', width: '1.5em', height: '1.5em', marginRight: 12}})}
                      {resourceInfo.name}
                    </Typography>
                    {
                      resourceInfo.description?
                        <Typography variant='subheading'>{resourceInfo.description}</Typography>
                      :
                        null
                    }
                  </Card>
                </Link>
              </Grid>
            )
          })
        }
      </Grid>
    );
  }
}

export default withTheme()(ResourceIndexGrid);


// WEBPACK FOOTER //
// ./src/components/ResourceIndexGrid.js